import {
  useCallback, useEffect, useState,
} from 'react';

const STORAGE_KEY = 'timeline-sidebar-collapsed';

/**
 * Reads the collapsed sidebar preference from localStorage.
 * Expanded by default when the key is missing or unreadable.
 * @returns {boolean}
 */
function readCollapsedFromStorage() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Collapsible sidebar state persisted in localStorage.
 * @returns {{
 *   isCollapsed: boolean,
 *   setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>,
 *   onToggleClick: () => void,
 * }}
 */
function useCollapsibleSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(readCollapsedFromStorage);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(isCollapsed));
    } catch {
      // Ignore quota / private-mode failures; in-memory state still works.
    }
  }, [isCollapsed]);

  const onToggleClick = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  return {
    isCollapsed,
    setIsCollapsed,
    onToggleClick,
  };
}

export default useCollapsibleSidebar;
